import React, { useState } from 'react';
import { Modal, Table } from 'antd';
import PropTypes from 'prop-types';
import PrettyJsonView from 'pretty-json-view';
import ApplicationContainer from '../application-container';

const SettingsTelegramUpdates = ({ updates = [] }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedPayload, setSelectedPayload] = useState('');

  const columns = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
    },
    {
      title: 'Telegram ID',
      dataIndex: 'updateId',
      key: 'updateId',
    },
    {
      title: 'Статус',
      dataIndex: 'status',
      key: 'status',
    },
    {
      title: 'Дані оновлення',
      dataIndex: 'payload',
      key: 'payload',
      render: (text) => <pre>{text.slice(0, 50)}...</pre>,
      onCell: (record) => ({
        onClick: () => {
          setIsOpen(true);
          setSelectedPayload(record.payload);
        },
      }),
    },
    {
      title: 'Створено',
      dataIndex: 'createdAt',
      key: 'createdAt',
      render: (text) => <pre>{text}</pre>,
    },
  ];

  return (
    <ApplicationContainer title="Повідомлення боту">
      <Table dataSource={updates} columns={columns} />
      <Modal title="Дані оновлення" open={isOpen} onCancel={() => setIsOpen(false)} footer={null}>
        {selectedPayload && <PrettyJsonView data={JSON.parse(selectedPayload)} />}
      </Modal>
    </ApplicationContainer>
  );
};

SettingsTelegramUpdates.propTypes = {
  updates: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    updateId: PropTypes.string.isRequired,
    status: PropTypes.string.isRequired,
    payload: PropTypes.string.isRequired,
    createdAt: PropTypes.string.isRequired,
  })),
};

export default SettingsTelegramUpdates;
